<template>
  <v-select
    v-bind="$attrs"
    v-on="$listeners"
    :items="items"
    filled
    dense
  ></v-select>
</template>

<script>

  export default {
    name: 'CurrencyUnit',
    data: () => ({
      items: [
        {
          text: 'HRK',
          value: 'hrk',
        },
        {
          text: 'EUR',
          value: 'eur',
        },
        {
          text: 'USD',
          value: 'usd',
        },
      ],
    }),
  }
</script>

<style scoped>

</style>
